import { render, staticRenderFns } from "./add_symptom.vue?vue&type=template&id=9acf4eb2&"
import script from "./add_symptom.vue?vue&type=script&lang=js&"
export * from "./add_symptom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports